// Used due to bug with yjs where "item" is sometimes undefined instead of null
export default function fixMissingItem (obj) {
  if (!obj) return null

  if (obj.item == null) return { ...obj, item: null }

  return obj
}
